import api from '../../services/api';

export interface Cuota {
  recnum: string;
  recurso: string;
  rdescripcion: string;
  anio: string;
  cuota: string;
  tipo_comprob: string;
  nro_comprob: string;
  situacion: string;
  estado: string;
  nro_plan: null;
  legal: string;
  descripcion: string;
  fecha_vto: string;
  fecha_vto2: string;
  fecha_vto3: string;
  vigente: string;
  monto_original: string;
  intereses: string;
  multa: string;
  descr_abrev: string;
}

export interface CuotaData {
  tipo: string;
  id: string;
  recurso: string;
}

async function getCuotasByResource(data: CuotaData) {
  const { tipo, id, recurso } = data;

  const response = await api<Cuota[]>(
    'GET',
    `imponibles/${tipo}-${id}/${recurso}`
  );

  return response;
}

const cuotasAPI = {
  getCuotasByResource,
};

export default cuotasAPI;
